export const userActionTypes = {
  FETCH_USERS_REQUEST: 'FETCH_USERS_REQUEST',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILURE: 'FETCH_USERS_FAILURE',

  RESET_STATE: 'USERS_RESET_STATE',
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT: 'USERS_LOGOUT',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',

  GETALL_REQUEST: 'USERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'USERS_GETALL_FAILURE',

  GET_REQUEST: 'USERS_GET_REQUEST',
  GET_SUCCESS: 'USERS_GET_SUCCESS',
  GET_FAILURE: 'USERS_GET_FAILURE',

  DETAILS_REQUEST: 'USERS_DETAILS_REQUEST',
  DETAILS_SUCCESS: 'USERS_DETAILS_SUCCESS',
  DETAILS_FAILURE: 'USERS_DETAILS_FAILURE',

  STATISTICS_REQUEST: 'USERS_STATISTICS_REQUEST',
  STATISTICS_SUCCESS: 'USERS_STATISTICS_SUCCESS',
  STATISTICS_FAILURE: 'USERS_STATISTICS_FAILURE',

  GET_DESIGNS_REQUEST: 'USERS_GET_DESIGNS_REQUEST',
  GET_DESIGNS_SUCCESS: 'USERS_GET_DESIGNS_SUCCESS',
  GET_DESIGNS_FAILURE: 'USERS_GET_DESIGNS_FAILURE',

  UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',
  UPDATE_USER: 'USERS_UPDATE_USER', // For change user in authentication state

  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_REFRESH_TOKEN: 'INVALID_REFRESH_TOKEN',
  REFRESHING_TOKEN: 'REFRESHING_TOKEN',
  PENDING_REFRESH_TOKEN: 'PENDING_REFRESH_TOKEN',
  TOKEN_REFRESHED: 'TOKEN_REFRESHED',
  RESEND: 'RESEND',

  GET_DASHBOARD_STATS_REQUEST: 'GET_DASHBOARD_STATS_REQUEST',
  GET_DASHBOARD_STATS_SUCCESS: 'GET_DASHBOARD_STATS_SUCCESS',
  GET_DASHBOARD_STATS_FAILURE: 'GET_DASHBOARD_STATS_FAILURE',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',

  AUTHENTICAT_REQUEST: 'USERS_AUTHENTICAT_REQUEST',
  AUTHENTICAT_SUCCESS: 'USERS_AUTHENTICAT_SUCCESS',
  AUTHENTICAT_FAILURE: 'USERS_AUTHENTICAT_FAILURE',

  CONFIRM_MOBILE_REQUEST: 'USERS_CONFIRM_MOBILE_REQUEST',
  CONFIRM_MOBILE_SUCCESS: 'USERS_CONFIRM_MOBILE_SUCCESS',
  CONFIRM_MOBILE_FAILURE: 'USERS_CONFIRM_MOBILE_FAILURE',

  RESEND_CONFIRMATION_SMS_REQUEST: 'USERS_RESEND_CONFIRMATION_SMS_REQUEST',
  RESEND_CONFIRMATION_SMS_SUCCESS: 'USERS_RESEND_CONFIRMATION_SMS_SUCCESS',
  RESEND_CONFIRMATION_SMS_FAILURE: 'USERS_RESEND_CONFIRMATION_SMS_FAILURE',

  FORGOT_PASSWORD_REQUEST: 'USERS_FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'USERS_FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'USERS_FORGOT_PASSWORD_FAILURE',

  RESET_PASSWORD_REQUEST: 'USERS_RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'USERS_RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'USERS_RESET_PASSWORD_FAILURE',

  CHANGE_PROFILE_PICTURE_REQUEST: 'USERS_CHANGE_PROFILE_PICTURE_REQUEST',
  CHANGE_PROFILE_PICTURE_SUCCESS: 'USERS_CHANGE_PROFILE_PICTURE_SUCCESS',
  CHANGE_PROFILE_PICTURE_FAILURE: 'USERS_CHANGE_PROFILE_PICTURE_FAILURE',
};

export const designActionTypes = {
  RESET_STATE: 'DESIGNS_RESET_STATE',
  CREATE_REQUEST: 'DESIGNS_CREATE_REQUEST',
  CREATE_SUCCESS: 'DESIGNS_CREATE_SUCCESS',
  CREATE_FAILURE: 'DESIGNS_CREATE_FAILURE',

  DUPLICATE_REQUEST: 'DESIGNS_DUPLICATE_REQUEST',
  DUPLICATE_SUCCESS: 'DESIGNS_DUPLICATE_SUCCESS',
  DUPLICATE_FAILURE: 'DESIGNS_DUPLICATE_FAILURE',

  SAVE_REQUEST: 'DESIGNS_SAVE_REQUEST',
  SAVE_SUCCESS: 'DESIGNS_SAVE_SUCCESS',
  SAVE_FAILURE: 'DESIGNS_SAVE_FAILURE',

  SAVE_AS_TEMPLATE_REQUEST: 'DESIGNS_SAVE_AS_TEMPLATE_REQUEST',
  SAVE_AS_TEMPLATE_SUCCESS: 'DESIGNS_SAVE_AS_TEMPLATE_SUCCESS',
  SAVE_AS_TEMPLATE_FAILURE: 'DESIGNS_SAVE_AS_TEMPLATE_FAILURE',

  FETCH_REQUEST: 'DESIGNS_FETCH_REQUEST',
  FETCH_SUCCESS: 'DESIGNS_FETCH_SUCCESS',
  FETCH_FAILURE: 'DESIGNS_FETCH_FAILURE',

  SEARCH_REQUEST: 'DESIGNS_SEARCH_REQUEST',
  SEARCH_SUCCESS: 'DESIGNS_SEARCH_SUCCESS',
  SEARCH_FAILURE: 'DESIGNS_SEARCH_FAILURE',

  EXPORT_REQUEST: 'DESIGNS_EXPORT_REQUEST',
  EXPORT_SUCCESS: 'DESIGNS_EXPORT_SUCCESS',
  EXPORT_FAILURE: 'DESIGNS_EXPORT_FAILURE',

  DELETE_REQUEST: 'DESIGNS_DELETE_REQUEST',
  DELETE_SUCCESS: 'DESIGNS_DELETE_SUCCESS',
  DELETE_FAILURE: 'DESIGNS_DELETE_FAILURE',

  ADD_PAGE: 'DESIGNS_ADD_PAGE',
  COPY_PAGE: 'DESIGNS_COPY_PAGE',
  DELETE_PAGE: 'DESIGNS_DELETE_PAGE',
  ADD_ENTITY: 'DESIGNS_ADD_ENTITY',
  DELETE_ENTITY: 'DESIGNS_DELETE_ENTITY',
  ADD_EDITOR_STATE: 'DESIGNS_ADD_EDITOR_STATE',
  ADD_SVG_STATE: 'DESIGNS_ADD_SVG_STATE',
  CHANGE_EDITOR_STATE: 'DESIGNS_CHANGE_EDITOR_STATE',
  CHANGE_SVG_STATE: 'DESIGNS_CHANGE_SVG_STATE',
  CHANGE_SELECTED_ENTITY: 'DESIGNS_CHANGE_SELECTED_ENTITY',
  CHANGE_ENTITY_EDITABLE_MODE: 'DESIGNS_CHANGE_ENTITY_EDITABLE_MODE',
  CHANGE_SVG_COLOR: 'DESIGNS_CHANGE_SVG_COLOR',
  CHANGE_IMAGE_FILTER: 'DESIGN_CHANGE_IMAGE_FILTER',
  CHANGE_ENTITY_DATA: 'DESIGN_CHANGE_ENTITY_DATA',
  CHANGE_COLOR_PICKER_COLOR: 'DESIGNS_CHANGE_COLOR_PICKER_COLOR',
  CHANGE_RECT_SELECTION: 'DESIGNS_CHANGE_RECT_SELECTION',
  CHANGE_IMAGE_STATE: 'DESIGNS_CHANGE_IMAGE_STATE',
  CHANGE_ENTITY_ARRANGE: 'DESIGNS_CHANGE_ENTITY_ARRANGE',
  CHANGE_ENTITY_STYLE: 'DESIGNS_CHANGE_ENTITY_STYLE',
  CHANGE_GROUP_ENTITY_STYLE: 'DESIGNS_CHANGE_GROUP_ENTITY_STYLE',
  SET_SIDE_PANEL: 'DESIGNS_SET_SIDE_PANEL',
  SHOW_FILTER_PANEL: 'DESIGNS_SHOW_FILTER_PANEL',
  LOAD_TEMPLATE_DESIGN: 'DESIGNS_LOAD_TEMPLATE_DESIGN',
  ADD_FONT: 'DESIGNS_ADD_FONT',
  CHANGE_DESIGN_SIZE: 'DESIGNS_CHANGE_DESIGN_SIZE',
  CHANGE_ENABLE_EDITOR: 'DESIGNS_CHANGE_ENABLE_EDITOR',
  CHANGE_ENTITY_SRC: 'DESIGNS_CHANGE_ENTITY_SRC',
  CHANGE_GRID_DATA: 'DESIGNS_CHANGE_GRID_DATA',
  CHANGE_FRAME_DATA: 'DESIGNS_CHANGE_FRAME_DATA',
  CHANGE_PAGE_BACKGROUND_COLOR: 'DESIGNS_CHANGE_PAGE_BACKGROUND_COLOR',
  DELETE_PAGE_BACKGROUND_COLOR: 'DESIGNS_DELETE_PAGE_BACKGROUND_COLOR',
  DELETE_PAGE_BACKGROUND_MEDIA: 'DESIGNS_DELETE_PAGE_BACKGROUND_MEDIA',
  CHANGE_DESIGN_PAGE_SCALE: 'DESIGNS_CHANGE_DESIGN_PAGE_SCALE',
  CHANGE_NAME: 'DESIGNS_CHANGE_NAME',
  DUPLICATE_ENTITY: 'DESIGNS_DUPLICATE_ENTITY',
  ADD_SPACING_STYLE_CLASS: 'DESIGNS_ADD_SPACING_STYLE_CLASS',
  ADD_LIST_BLOCK_STYLE_CLASS: 'DESIGNS_ADD_LIST_BLOCK_STYLE_CLASS',
  REPLACE_ENTITY_STATE: 'DESIGNS_REPLACE_ENTITY_STATE',
  SET_CURRENT_TEXT_INLINE_STYLE: 'DESIGNS_SET_CURRENT_TEXT_INLINE_STYLE',
  CHANGE_LOCK_STATE: 'DESIGNS_CHANGE_LOCK_STATE',
};

export const resourceActionTypes = {
  RESET_STATE: 'RESOURCES_RESET_STATE',

  UPLOAD_REQUEST: 'RESOURCES_UPLOAD_REQUEST',
  UPLOAD_SUCCESS: 'RESOURCES_UPLOAD_SUCCESS',
  UPLOAD_FAILURE: 'RESOURCES_UPLOAD_FAILURE',

  SEARCH_REQUEST: 'RESOURCES_SEARCH_REQUEST',
  SEARCH_SUCCESS: 'RESOURCES_SEARCH_SUCCESS',
  SEARCH_FAILURE: 'RESOURCES_SEARCH_FAILURE',

  UPDATE_REQUEST: 'RESOURCES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'RESOURCES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'RESOURCES_UPDATE_FAILURE',

  USER_RESOURCE_REQUEST: 'RESOURCES_USER_RESOURCE_REQUEST',
  USER_RESOURCE_SUCCESS: 'RESOURCES_USER_RESOURCE_SUCCESS',
  USER_RESOURCE_FAILURE: 'RESOURCES_USER_RESOURCE_FAILURE',

  DELETE_REQUEST: 'RESOURCES_DELETE_REQUEST',
  DELETE_SUCCESS: 'RESOURCES_DELETE_SUCCESS',
  DELETE_FAILURE: 'RESOURCES_DELETE_FAILURE',
  
  USER_FOLDERS_REQUEST: 'RESOURCES_USER_FOLDERS_REQUEST',
  USER_FOLDERS_SUCCESS: 'RESOURCES_USER_FOLDERS_SUCCESS',
  USER_FOLDERS_FAILURE: 'RESOURCES_USER_FOLDERS_FAILURE',
  USER_ACTION_REQUEST: 'RESOURCES_USER_ACTION_REQUEST',
  USER_ACTION_SUCCESS: 'RESOURCES_USER_ACTION_SUCCESS',
  USER_ACTION_FAILURE: 'RESOURCES_USER_ACTION_FAILURE',
  USER_FOLDER_RESOURCES_REQUEST: 'RESOURCES_USER_FOLDER_RESOURCES_REQUEST',
  USER_FOLDER_RESOURCES_SUCCESS: 'RESOURCES_USER_FOLDER_RESOURCES_SUCCESS',
  USER_FOLDER_RESOURCES_FAILURE: 'RESOURCES_USER_FOLDER_RESOURCES_FAILURE',
  IMAGE_TAGS_REQUEST: 'RESOURCES_IMAGE_TAGS_REQUEST',
  IMAGE_TAGS_SUCCESS: 'RESOURCES_IMAGE_TAGS_SUCCESS',
  IMAGE_TAGS_FAILURE: 'RESOURCES_IMAGE_TAGS_FAILURE',
  CREATE_FOLDER_REQUEST: 'RESOURCES_CREATE_FOLDER_REQUEST',
  CREATE_FOLDER_SUCCESS: 'RESOURCES_CREATE_FOLDER_SUCCESS',
  CREATE_FOLDER_FAILURE: 'RESOURCES_CREATE_FOLDER_FAILURE',
  DELETE_FOLDER_REQUEST: 'RESOURCES_DELETE_FOLDER_REQUEST',
  DELETE_FOLDER_SUCCESS: 'RESOURCES_DELETE_FOLDER_SUCCESS',
  DELETE_FOLDER_FAILURE: 'RESOURCES_DELETE_FOLDER_FAILURE',
  ADD_TO_FOLDER_REQUEST: 'RESOURCES_ADD_TO_FOLDER_REQUEST',
  ADD_TO_FOLDER_SUCCESS: 'RESOURCES_ADD_TO_FOLDER_SUCCESS',
  ADD_TO_FOLDER_FAILURE: 'RESOURCES_ADD_TO_FOLDER_FAILURE',
  REMOVE_FROM_FOLDER_REQUEST: 'RESOURCES_REMOVE_FROM_FOLDER_REQUEST',
  REMOVE_FROM_FOLDER_SUCCESS: 'RESOURCES_REMOVE_FROM_FOLDER_SUCCESS',
  REMOVE_FROM_FOLDER_FAILURE: 'RESOURCES_REMOVE_FROM_FOLDER_FAILURE',
};

export const templateActionTypes = {
  RESET_STATE: 'TEMPlATES_RESET_STATE',
  CREATE_REQUEST: 'TEMPlATES_CREATE_REQUEST',
  CREATE_SUCCESS: 'TEMPlATES_CREATE_SUCCESS',
  CREATE_FAILURE: 'TEMPlATES_CREATE_FAILURE',

  FETCH_REQUEST: 'TEMPlATES_FETCH_REQUEST',
  FETCH_SUCCESS: 'TEMPlATES_FETCH_SUCCESS',
  FETCH_FAILURE: 'TEMPlATES_FETCH_FAILURE',

  SEARCH_REQUEST: 'TEMPlATES_SEARCH_REQUEST',
  SEARCH_SUCCESS: 'TEMPlATES_SEARCH_SUCCESS',
  SEARCH_FAILURE: 'TEMPlATES_SEARCH_FAILURE',

  UPDATE_REQUEST: 'TEMPlATES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'TEMPlATES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'TEMPlATES_UPDATE_FAILURE',

  SELECT_TEMPLATE: 'TEMPLATES_SELECT_TEMPLATE',
};

export const graphicBuilderActionTypes = {
  RESET_STATE: 'GRAPHIC_BUILDER_RESET_STATE',
  CAN_DROP: 'GRAPHIC_BUILDER_CAN_DROP',
};

export const subscriptionActionTypes = {
  RESET_STATE: 'SUBSCRIPTION_RESET_STATE',

  FETCH_REQUEST: 'SUBSCRIPTION_FETCH_REQUEST',
  FETCH_SUCCESS: 'SUBSCRIPTION_FETCH_SUCCESS',
  FETCH_FAILURE: 'SUBSCRIPTION_FETCH_FAILURE',

  FETCH_LIST_REQUEST: 'SUBSCRIPTION_FETCH_LIST_REQUEST',
  FETCH_LIST_SUCCESS: 'SUBSCRIPTION_FETCH_LIST_SUCCESS',
  FETCH_LIST_FAILURE: 'SUBSCRIPTION_FETCH_LIST_FAILURE',

  CREATE_REQUEST: 'SUBSCRIPTION_CREATE_REQUEST',
  CREATE_SUCCESS: 'SUBSCRIPTION_CREATE_SUCCESS',
  CREATE_FAILURE: 'SUBSCRIPTION_CREATE_FAILURE',

  CANCEL_DRAFT_REQUEST: 'SUBSCRIPTION_CANCEL_DRAFT_REQUEST',
  CANCEL_DRAFT_SUCCESS: 'SUBSCRIPTION_CANCEL_DRAFT_SUCCESS',
  CANCEL_DRAFT_FAILURE: 'SUBSCRIPTION_CANCEL_DRAFT_FAILURE',

  PAY_INVOICE_REQUEST: 'SUBSCRIPTION_PAY_INVOICE_REQUEST',
  PAY_INVOICE_SUCCESS: 'SUBSCRIPTION_PAY_INVOICE_SUCCESS',
  PAY_INVOICE_FAILURE: 'SUBSCRIPTION_PAY_INVOICE_FAILURE',

  USE_COUPON_REQUEST: 'SUBSCRIPTION_USE_COUPON_REQUEST',
  USE_COUPON_SUCCESS: 'SUBSCRIPTION_USE_COUPON_SUCCESS',
  USE_COUPON_FAILURE: 'SUBSCRIPTION_USE_COUPON_FAILURE',

  GET_CURRENT_REQUEST: 'SUBSCRIPTION_GET_CURRENT_REQUEST',
  GET_CURRENT_SUCCESS: 'SUBSCRIPTION_GET_CURRENT_SUCCESS',
  GET_CURRENT_FAILURE: 'SUBSCRIPTION_GET_CURRENT_FAILURE',

  GET_USER_REQUEST: 'SUBSCRIPTION_GET_USER_REQUEST',
  GET_USER_SUCCESS: 'SUBSCRIPTION_GET_USER_SUCCESS',
  GET_USER_FAILURE: 'SUBSCRIPTION_GET_USER_FAILURE',
};

export const referralActionTypes = {
  RESET_STATE: 'REFERRAL_RESET_STATE',

  FETCH_REQUEST: 'REFERRAL_FETCH_REQUEST',
  FETCH_SUCCESS: 'REFERRAL_FETCH_SUCCESS',
  FETCH_FAILURE: 'REFERRAL_FETCH_FAILURE',

  FIND_REQUEST: 'REFERRAL_FIND_REQUEST',
  FIND_SUCCESS: 'REFERRAL_FIND_SUCCESS',
  FIND_FAILURE: 'REFERRAL_FIND_FAILURE',

  CREATE_REQUEST: 'REFERRAL_CREATE_REQUEST',
  CREATE_SUCCESS: 'REFERRAL_CREATE_SUCCESS',
  CREATE_FAILURE: 'REFERRAL_CREATE_FAILURE',

  UPDATE_REQUEST: 'REFERRAL_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'REFERRAL_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'REFERRAL_UPDATE_FAILURE',

  ADD_CODE_REQUEST: 'REFERRAL_ADD_CODE_REQUEST',
  ADD_CODE_SUCCESS: 'REFERRAL_ADD_CODE_SUCCESS',
  ADD_CODE_FAILURE: 'REFERRAL_ADD_CODE_FAILURE',

  UPDATE_CODE_REQUEST: 'REFERRAL_UPDATE_CODE_REQUEST',
  UPDATE_CODE_SUCCESS: 'REFERRAL_UPDATE_CODE_SUCCESS',
  UPDATE_CODE_FAILURE: 'REFERRAL_UPDATE_CODE_FAILURE',
};

export const roleActionTypes = {
  RESET_STATE: 'ROLE_RESET_STATE',

  FETCH_REQUEST: 'ROLE_FETCH_REQUEST',
  FETCH_SUCCESS: 'ROLE_FETCH_SUCCESS',
  FETCH_FAILURE: 'ROLE_FETCH_FAILURE',

};

export const paymentActionTypes = {
  RESET_STATE: 'PAYMENT_RESET_STATE',

  REPORT_REQUEST: 'PAYMENT_REPORT_REQUEST',
  REPORT_SUCCESS: 'PAYMENT_REPORT_SUCCESS',
  REPORT_FAILURE: 'PAYMENT_REPORT_FAILURE',
};

export const planActionTypes = {
  RESET_STATE: 'PLAN_RESET_STATE',

  GETALL_REQUEST: 'PLAN_GETALL_REQUEST',
  GETALL_SUCCESS: 'PLAN_GETALL_SUCCESS',
  GETALL_FAILURE: 'PLAN_GETALL_FAILURE',

  CREATE_REQUEST: 'PLAN_CREATE_REQUEST',
  CREATE_SUCCESS: 'PLAN_CREATE_SUCCESS',
  CREATE_FAILURE: 'PLAN_CREATE_FAILURE',

  UPDATE_REQUEST: 'PLAN_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PLAN_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PLAN_UPDATE_FAILURE',
};

export const couponActionTypes = {
  RESET_STATE: 'COUPON_RESET_STATE',

  GET_ALL_REQUEST: 'COUPON_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'COUPON_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'COUPON_GET_ALL_FAILURE',

  FIND_REQUEST: 'COUPON_FIND_REQUEST',
  FIND_SUCCESS: 'COUPON_FIND_SUCCESS',
  FIND_FAILURE: 'COUPON_FIND_FAILURE',

  FIND_ALL_REQUEST: 'COUPON_FIND_ALL_REQUEST',
  FIND_ALL_SUCCESS: 'COUPON_FIND_ALL_SUCCESS',
  FIND_ALL_FAILURE: 'COUPON_FIND_ALL_FAILURE',

  CREATE_REQUEST: 'COUPON_CREATE_REQUEST',
  CREATE_SUCCESS: 'COUPON_CREATE_SUCCESS',
  CREATE_FAILURE: 'COUPON_CREATE_FAILURE',

  UPDATE_REQUEST: 'COUPON_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'COUPON_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'COUPON_UPDATE_FAILURE',

  GET_DASHBOARD_STATS_REQUEST: 'GET_DASHBOARD_STATS_REQUEST',
  GET_DASHBOARD_STATS_SUCCESS: 'GET_DASHBOARD_STATS_SUCCESS',
  GET_DASHBOARD_STATS_FAILURE: 'GET_DASHBOARD_STATS_FAILURE',
};

export const dashboardActionTypes = {
  SUMMARY_REQUEST: 'DASHBOARD_SUMMARY_REQUEST',
  SUMMARY_SUCCESS: 'DASHBOARD_SUMMARY_SUCCESS',
  SUMMARY_FAILURE: 'DASHBOARD_SUMMARY_FAILURE',

  CHARTS_REQUEST: 'DASHBOARD_CHARTS_REQUEST',
  CHARTS_SUCCESS: 'DASHBOARD_CHARTS_SUCCESS',
  CHARTS_FAILURE: 'DASHBOARD_CHARTS_FAILURE',
};
